const iphoneModels = {
  singleCamera: [
    { model: "iPhone XR", cameraType: "wide" },
    { model: "iPhone SE (2nd gen)", cameraType: "wide" },
    { model: "iPhone SE (3rd gen)", cameraType: "wide" },
    { model: "iPhone 16e", cameraType: "wide" },
    { model: "iPhone Air", cameraType: "wide" }
  ],

  nonProMultiCamera: [
    { model: "iPhone XS / XS Max", cameraType: "wide" },
    { model: "iPhone 11", cameraType: "wide" },
    { model: "iPhone 12 / 12 mini", cameraType: "wide" },
    { model: "iPhone 13 / 13 mini", cameraType: "wide" },
    { model: "iPhone 14 / 14 Plus", cameraType: "wide" },
    { model: "iPhone 15 / 15 Plus", cameraType: "wide" },
    { model: "iPhone 16 / 16 Plus", cameraType: "ultrawide" },
    { model: "iPhone 17", cameraType: "ultrawide" }
  ],

  proModels: [
    { model: "iPhone 11 Pro / Pro Max", cameraType: "wide" },
    { model: "iPhone 12 Pro / Pro Max", cameraType: "wide" },
    { model: "iPhone 13 Pro / Pro Max", cameraType: "triple" },
    { model: "iPhone 14 Pro / Pro Max", cameraType: "triple" },
    { model: "iPhone 15 Pro / Pro Max", cameraType: "triple" },
    { model: "iPhone 16 Pro / Pro Max", cameraType: "triple" },
    { model: "iPhone 17 Pro / Pro Max", cameraType: "triple" }
  ]
};

export default iphoneModels;
